import React from 'react';
import { InfoLinkCardsProps } from './info-link-cards.d';
import { InfoLinkCards } from '/react4xp/parts/infoLinkCards/InfoLinkCards';


export default function (props: InfoLinkCardsProps): JSX.Element {
	return <InfoLinkCards {...props} />;
}
